
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/topBar/secondaryActionsExtensionSlot/secondaryActionsExtensionSlot.scss.css.virtualfile';
        module.exports = {"secondary-action-btn":"_secondary-action-btn_1vsa4_1","secondaryActionBtn":"_secondary-action-btn_1vsa4_1"};